module.exports = __webpack_public_path__ + "img/供电设备.a09f3ba7.gif";